import {useContext} from "react";

import {CurrentUserContext} from "../providers/CurrentUserProvider";

export const useCurrentUser = () => {

    const {currentUser, loading} = useContext(CurrentUserContext);
    return {currentUser, loading};
};
